import { useGetAttachmentsByDocId } from "@/api/attachment";
import StyledDrawer from "@/components/StyledDrawer";
import AddCroppedImageForm from "@/components/images/AddCroppedImageForm";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/auth/AuthContext";
import { Attachment } from "@/lib/types";
import { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormFieldProps } from "./types";

const ImageField = memo(({ config, positionImage }: FormFieldProps) => {
  const { instanceData } = useAuth();
  const { data: imageAttachments, refetch } = useGetAttachmentsByDocId(
    instanceData?.id,
  );
  const [imageURL, setImageURL] = useState<string | null>(null);
  const [attachment, setAttachment] = useState<Attachment | null>(null);

  const loadImage = async () => {
    const image = imageAttachments?.find(
      (attachment) => attachment.position === positionImage,
    );
    if (image) {
      setImageURL(image.mediumPublicUrl as string);
      setAttachment(image);
    }
  };

  const { t } = useTranslation();

  useEffect(() => {
    if (imageAttachments) {
      loadImage();
    }
  }, [imageAttachments]);

  return (
    <div className="w-full inline-flex flex-col justify-start">
      <div className="justify-between items-center gap-1.5 inline-flex pt-2">
        <p className="text-slate-700 text-sm font-medium font-['Raleway'] leading-normal">
          {t(config.label ?? "image")}
        </p>
        <StyledDrawer
          className="min-w-full"
          title={t("cmsAjouterImageTitre")}
          trigger={
            <Button className="font-semibold flex gap-2" variant="outline">
              {t("cmsChangerImageBouton")}
            </Button>
          }
        >
          <AddCroppedImageForm
            attachment={attachment ?? undefined}
            refetch={refetch}
            imagePosition={positionImage ?? ""}
            aspect={0.78}
            buildImageName={() => ""}
          />
        </StyledDrawer>
      </div>
      {imageURL && (
        <img
          className="h-auto mt-3 w-1/2 mb-3"
          src={imageURL}
          alt={t(config.label ?? "image")}
        />
      )}
    </div>
  );
});

ImageField.displayName = "ImageField";
export default ImageField;
